import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./menubar.css";
import issuebook from "../../assert/icons/issue_book.png";
import managebook from "../../assert/icons/manage_book.png";
import addbook from "../../assert/icons/manage_book (2).png";
import managerack from "../../assert/icons/book-shelf.png";
import upcoming from "../../assert/icons/return.png";
import upcoming2 from "../../assert/icons/return (2).png";
import notreturn from "../../assert/icons/book-keeping.png";
import logout from "../../assert/icons/logout.png";
import importBooks from "../../assert/icons/import_books.png";
import shareBook from "../../assert/icons/share.png";
import shareBook2 from "../../assert/icons/share (2).png";
import users from "../../assert/icons/group.png";

import { NavLink } from "react-router-dom";

function MenuBar(prop) {
  const navigate = useNavigate();
  // const [activeLink, setActiveLink] = useState("");

  // const handleClick = (link) => {
  //   setActiveLink(link);
  //   prop.setupdate(Date.now());
  // };

  const Logouthandler = () => {
    localStorage.removeItem("token");
    // navigate("/admin/login");
  };

  return (
    <>
      <div className="left-side-menu">
        <div className="logo">{/* Your logo here */}</div>
        <div className="menu-items">
          <NavLink
            end
            className={({ isActive }) => isActive ? "active menu-item" : "menu-item"}
            to="/admin/"
            id="link-1"
          >
            <img src={issuebook} alt="isssue" />
            <span>Issue Book</span>
          </NavLink>

          <NavLink
            className={({ isActive }) => isActive ? "active menu-item" : "menu-item"}
            to="/admin/users"
            id="link-2"
          >
            <img src={users} alt="users" />
            <span>Users</span>
          </NavLink>

          <NavLink
            className={({ isActive }) => isActive ? "active menu-item" : "menu-item"}
            to="/admin/managebook"
            id="link-3"
          >
            <img src={addbook} alt="book" />
            <span>Manage Books</span>
          </NavLink>

          <NavLink
            className={({ isActive }) => isActive ? "active menu-item" : "menu-item"}
            to="/admin/importbooks"
            id="link-4"
          >
            <img src={importBooks} alt="book" />
            <span>Import Books</span>
          </NavLink>

          <NavLink
            className={({ isActive }) => isActive ? "active menu-item" : "menu-item"}
            to="/admin/department"
            id="link-5"
          >
            <img src={managebook} alt="book" />
            <span>Manage Department</span>
          </NavLink>

          <NavLink
            className={({ isActive }) => isActive ? "active menu-item" : "menu-item"}

            to="/admin/subdepartment"
            id="link-6"
          >
            <img src={managebook} alt="book" />
            <span>Manage Sub Department</span>
          </NavLink>

          <NavLink
            to="/admin/managerack"
            className={({ isActive }) => isActive ? "active menu-item" : "menu-item"}
            id="link-7"
          >
            <img src={managerack} alt="rack" />
            <span>Manage Racks</span>
          </NavLink>

          <NavLink
            to="/admin/return_book"
            className={({ isActive }) => isActive ? "active menu-item" : "menu-item"}
            id="link-8"
          >
            <img src={notreturn} alt="Contact" />
            <span>Return Book</span>
          </NavLink>

          <NavLink
            to="/admin/upcoming_books_return"
            className={({ isActive }) => isActive ? "active menu-item" : "menu-item"}
            id="link-9"
          >
            <img src={upcoming} alt="upcoming" />
            <span>Upcoming Books Return</span>
          </NavLink>

          <NavLink
            className={({ isActive }) => isActive ? "active menu-item" : "menu-item"}
            to="/admin/books"
            id="link-10"
          >
            <img src={shareBook2} alt="upcoming" />
            <span>Share Books</span>
          </NavLink>

          <NavLink
            className={({ isActive }) => isActive ? "active menu-item" : "menu-item"}
            to="/admin/books_without_summary"
            id="link-11"
          >
            <img src={shareBook2} alt="upcoming" />
            <span>Share Books Without Summary</span>
          </NavLink>

          {/* <div className="menu-item" onClick={() => document.querySelector("#link-11").click()}>
            <Link style={{ color: 'white' }} to="/admin/books" onClick={Logouthandler} id="link-11">
              <img src={logout} alt="logout" />
              <span>Logout</span>
            </Link>
          </div> */}

          <NavLink onClick={Logouthandler} className={({ isActive }) => isActive ? "active menu-item" : "menu-item"} to="/admin/login" id="link-12">
            <img src={logout} alt="logout" />
            <span>Logout</span>
          </NavLink>
        </div>
        <div style={{ marginTop: "80%" }}>
          <p style={{ fontWeight: 600, fontSize: "15px", textAlign: "center" }}>Version : 1.0.7</p>
        </div>
      </div>
    </>
  );
}

export default MenuBar;
